import { render, staticRenderFns } from "./DocumentTypeSetting.vue?vue&type=template&id=50d21b42"
import script from "./DocumentTypeSetting.vue?vue&type=script&lang=js"
export * from "./DocumentTypeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d21b42')) {
      api.createRecord('50d21b42', component.options)
    } else {
      api.reload('50d21b42', component.options)
    }
    module.hot.accept("./DocumentTypeSetting.vue?vue&type=template&id=50d21b42", function () {
      api.rerender('50d21b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/DocumentTypeSetting.vue"
export default component.exports